import service from './http'
/**
 * 渠道商相关接口
 */
// 渠道商详细信息
export function ChannelFindInfo(data) {
    return service({
      url: '/channel/findInfo',
      method: 'get',
      params: data,
      headers: {
        Authorization: localStorage.getItem('shangke_token')
      }
    })
  }
  export function ChannelLOgin(data) {
    return service({
      url: '/channel/channelLogin',
      method: 'get',
      params: data,
      headers: {
        Authorization: localStorage.getItem('shangke_token')
      }
    })
  }
